import {createStore, applyMiddleware, compose} from 'redux';
import createSagaMiddleware from 'redux-saga';
import {
  connectRouter,
  routerMiddleware,
} from 'connected-react-router'

/* Middlewares */
import promisifyAsyncActionsMiddleware from '../../../universal/redux/core/promisifyAsyncActionsMiddleware'
import createErrorMiddleware from '../../../universal/redux/core/errorMiddleware'
import routeNavigationMiddleware from '../../../universal/redux/core/routeNavigationMiddleware'

/* Utils */
import {
  generateRootReducer,
  generateClientRootSaga,
  generateInitialReduxStoreState,
} from '../../../universal/redux/core/storefrontReduxUtils'
import createStorefrontReduxErrorHandler from '../../../universal/redux/core/error/storefrontReduxErrorHandler'
import clientReduxErrorReporter from '../error/clientReduxErrorReporter'

/* Config */
import appConfig from '../../../universal/appConfig'

const createClientReduxStore = (injections, customInitialState) => {
  const {history} = injections;
  const rootReducer = generateRootReducer();
  const rootSaga = generateClientRootSaga(injections);
  const sagaMiddleware = createSagaMiddleware();
  const middlewares = [
    routeNavigationMiddleware,
    routerMiddleware(history),
    sagaMiddleware,
    createErrorMiddleware(
      createStorefrontReduxErrorHandler(
        clientReduxErrorReporter
      )
    ),
    promisifyAsyncActionsMiddleware,
  ];

  const composed = appConfig.reduxDevToolEnabled
    ? [applyMiddleware(...middlewares), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()]
    : [applyMiddleware(...middlewares)];

  const store = createStore(
    connectRouter(history)(rootReducer),
    generateInitialReduxStoreState(customInitialState),
    compose(...composed),
  );

  sagaMiddleware.run(rootSaga);

  return store;
};

export {createClientReduxStore};
